import {
  FETCH_TOTAL_LOAN_BENEFICIARIES_DETAILS_SUCCESS,
  FETCH_ALL_LOAN_BENEFICIARIES_LS_SUCCESS,
  FETCH_DATA_FOR_PRINTING_SUCCESS,
  ADD_PAYMENT_TO_LOAN_BENEFICIARY,
  ADD_PAYMENT_TO_LOAN_BENEFICIARY_SUCCESS,
  FETCH_PAYMENT_BY_LOAN_BENEFICIARY_ID,
  FETCH_PAYMENT_BY_LOAN_BENEFICIARY_ID_SUCCESS,
  FETCH_DATA_FOR_PRINTING,
  MAKE_REQUEST_LOAN_STATUS,
  RESTORE_LOAN_STATUS_INITIAL,
  FETCH_PAYMENT_BY_PAYMENT_ID,
  FETCH_PAYMENT_BY_PAYMENT_ID_SUCCESS,
  EXPORT_LOAN_BENEFICIARIES,
  EXPORT_LOAN_BENEFICIARIES_SUCCESS,
  FETCH_ALL_LOANS_FOR_FILTER_SUCCESS,
  FETCH_LOAN_BENEFICIARY_BY_ID_SUCCESS,
} from "../ActionTypes"

const INIT_STATE = {
  dashboardData: {},
  tableMetaData: {},
  allFetchedLoanBeneficiaries: [],
  dataForPrinting: [],
  listOfPaymentsForOneLB: [],
  particularPaymentToBeViewed: {},
  allLoansForFilter: [],
  fetchedLoanBeneficiaryByIdData: {},

  fetchingparticularPaymentToBeViewed: false,
  fetchingDataForPrinting: false,
  makingRequestLoanStatus: false,
  lbPaymentAddedSuccessfully: false,
  lbAddingPayment: false,
  fetchingPaymentsForLB: false,
  downloadingExportFile: false,
}

const reducers = (state = INIT_STATE, action) => {
  // console.log('action: ', action)
  switch (action.type) {
    case FETCH_TOTAL_LOAN_BENEFICIARIES_DETAILS_SUCCESS: return { // get dashboard data
      ...state,
      dashboardData: action.payload.data
    }

    case FETCH_ALL_LOAN_BENEFICIARIES_LS_SUCCESS: return {
      ...state,
      allFetchedLoanBeneficiaries: action.payload.data,
      tableMetaData: action.payload.meta,
      makingRequestLoanStatus: false,
    }

    case FETCH_DATA_FOR_PRINTING: return {
      ...state,
      fetchingDataForPrinting: true,
    }

    case FETCH_DATA_FOR_PRINTING_SUCCESS: return {
      ...state,
      dataForPrinting: action.payload.data,
      makingRequestLoanStatus: false,
      fetchingDataForPrinting: false,
    }

    case ADD_PAYMENT_TO_LOAN_BENEFICIARY: return {
      ...state,
      lbAddingPayment: true,
    }

    case ADD_PAYMENT_TO_LOAN_BENEFICIARY_SUCCESS: return {
      ...state,
      lbPaymentAddedSuccessfully: true,
      lbAddingPayment: false,
    }

    case FETCH_PAYMENT_BY_LOAN_BENEFICIARY_ID: return {
      ...state,
      fetchingPaymentsForLB: true,
    }

    case FETCH_PAYMENT_BY_LOAN_BENEFICIARY_ID_SUCCESS: return {
      ...state,
      listOfPaymentsForOneLB: action.payload.data,
      fetchingPaymentsForLB: false,
    }

    case FETCH_PAYMENT_BY_PAYMENT_ID: return {
      ...state,
      fetchingparticularPaymentToBeViewed: true,
    }

    case FETCH_PAYMENT_BY_PAYMENT_ID_SUCCESS: return {
      ...state,
      fetchingparticularPaymentToBeViewed: false,
      particularPaymentToBeViewed: action.payload.data,
    }

    case MAKE_REQUEST_LOAN_STATUS: return {
      ...state,
      makingRequestLoanStatus: true,
    }

    case EXPORT_LOAN_BENEFICIARIES: return {
      ...state,
      downloadingExportFile: true,
    }

    case EXPORT_LOAN_BENEFICIARIES_SUCCESS: return {
      ...state,
      downloadingExportFile: false,
    }

    case FETCH_ALL_LOANS_FOR_FILTER_SUCCESS: return {
      ...state,
      allLoansForFilter: action.payload
    }

    case FETCH_LOAN_BENEFICIARY_BY_ID_SUCCESS: return {
      ...state,
      fetchedLoanBeneficiaryByIdData: action.payload.data
    }

    case RESTORE_LOAN_STATUS_INITIAL: return {
      ...state,
      makingRequestLoanStatus: false,
      lbPaymentAddedSuccessfully: false,
      dataForPrinting: [],
    }

    default: return state
  }

}

export default reducers